import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotFoundComponent } from "./404-not-found.component";
import { UnauthorizeComponent } from "./unauthorize/unauthorize.component";
import { SessionExpiredComponent } from "./session-expired/session-expired.component";
import { NotFoundModule } from "@board/cloud-library/components/not-found";
import { UnauthorizeModule } from "@board/cloud-library/components/unauthorize";
import { UserMessageModule } from "@board/cloud-library/components/user-message";

const components = [NotFoundComponent, UnauthorizeComponent, SessionExpiredComponent];

@NgModule({
  imports: [CommonModule, NotFoundModule, UnauthorizeModule, UserMessageModule],
  exports: [components, UserMessageModule],
  declarations: [components]
})
export class CoreModule {}
